import _defineProperty from "/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { Keyframes, unit } from '@ant-design/cssinjs';
import { resetComponent } from '../../style';
import { genStyleHooks, mergeToken } from '../../theme/internal';
export var LineStrokeColorVar = '--progress-line-stroke-color';
export var Percent = '--progress-percent';
var genAntProgressActive = function genAntProgressActive(isRtl) {
  var direction = isRtl ? '100%' : '-100%';
  return new Keyframes("antProgress".concat(isRtl ? 'RTL' : 'LTR', "Active"), {
    '0%': {
      transform: "translateX(".concat(direction, ") scaleX(0)"),
      opacity: 0.1
    },
    '20%': {
      transform: "translateX(".concat(direction, ") scaleX(0)"),
      opacity: 0.5
    },
    to: {
      transform: 'translateX(0) scaleX(1)',
      opacity: 0
    }
  });
};
var genBaseStyle = function genBaseStyle(token) {
  var _$concat5, _$concat6, _$concat8, _$concat9, _Object$assign;
  var progressCls = token.componentCls,
    iconPrefixCls = token.iconCls;
  return _defineProperty({}, progressCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    display: 'inline-block',
    '&-rtl': {
      direction: 'rtl'
    },
    '&-line': {
      position: 'relative',
      width: '100%',
      fontSize: token.fontSize
    }
  }, _defineProperty(_Object$assign, "".concat(progressCls, "-outer"), {
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%'
  }), _defineProperty(_Object$assign, "".concat(progressCls, "-inner"), {
    position: 'relative',
    display: 'inline-block',
    width: '100%',
    flex: 1,
    overflow: 'hidden',
    verticalAlign: 'middle',
    backgroundColor: token.remainingColor,
    borderRadius: token.lineBorderRadius
  }), _defineProperty(_Object$assign, "".concat(progressCls, "-inner:not(").concat(progressCls, "-circle-gradient)"), _defineProperty({}, "".concat(progressCls, "-circle-path"), {
    stroke: token.defaultColor
  })), _defineProperty(_Object$assign, "".concat(progressCls, "-success-bg, ").concat(progressCls, "-bg"), {
    position: 'relative',
    background: token.defaultColor,
    borderRadius: token.lineBorderRadius,
    transition: "all ".concat(token.motionDurationSlow, " ").concat(token.motionEaseInOutCirc)
  }), _defineProperty(_Object$assign, "".concat(progressCls, "-layout-bottom"), _defineProperty({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  }, "".concat(progressCls, "-text"), {
    width: 'max-content',
    marginInlineStart: 0,
    marginTop: token.marginXXS
  })), _defineProperty(_Object$assign, "".concat(progressCls, "-bg"), _defineProperty({
    overflow: 'hidden',
    '&::after': {
      content: '""',
      background: {
        _multi_value_: true,
        value: ['inherit', "var(".concat(LineStrokeColorVar, ")")]
      },
      height: '100%',
      width: "calc(1 / var(".concat(Percent, ") * 100%)"),
      display: 'block'
    }
  }, "&".concat(progressCls, "-bg-inner"), _defineProperty({
    minWidth: 'max-content',
    '&::after': {
      content: 'none'
    }
  }, "".concat(progressCls, "-text-inner"), _defineProperty({
    color: token.colorWhite
  }, "&".concat(progressCls, "-text-bright"), {
    color: 'rgba(0, 0, 0, 0.45)'
  })))), _defineProperty(_Object$assign, "".concat(progressCls, "-success-bg"), {
    position: 'absolute',
    insetBlockStart: 0,
    insetInlineStart: 0,
    backgroundColor: token.colorSuccess
  }), _defineProperty(_Object$assign, "".concat(progressCls, "-text"), (_$concat5 = {
    display: 'inline-block',
    marginInlineStart: token.marginXS,
    color: token.colorText,
    lineHeight: 1,
    width: '2em',
    whiteSpace: 'nowrap',
    textAlign: 'start',
    verticalAlign: 'middle',
    wordBreak: 'normal'
  }, _defineProperty(_$concat5, iconPrefixCls, {
    fontSize: token.fontSize
  }), _defineProperty(_$concat5, "&".concat(progressCls, "-text-outer"), {
    width: 'max-content'
  }), _defineProperty(_$concat5, "&".concat(progressCls, "-text-outer").concat(progressCls, "-text-start"), {
    width: 'max-content',
    marginInlineStart: 0,
    marginInlineEnd: token.marginXS
  }), _$concat5)), _defineProperty(_Object$assign, "".concat(progressCls, "-text-inner"), (_$concat6 = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    marginInlineStart: 0,
    padding: "0 ".concat(unit(token.paddingXXS))
  }, _defineProperty(_$concat6, "&".concat(progressCls, "-text-start"), {
    justifyContent: 'start'
  }), _defineProperty(_$concat6, "&".concat(progressCls, "-text-end"), {
    justifyContent: 'end'
  }), _$concat6)), _defineProperty(_Object$assign, "&".concat(progressCls, "-status-active"), _defineProperty({}, "".concat(progressCls, "-bg::before"), {
    position: 'absolute',
    inset: 0,
    backgroundColor: token.colorBgContainer,
    borderRadius: token.lineBorderRadius,
    opacity: 0,
    animationName: genAntProgressActive(),
    animationDuration: token.progressActiveMotionDuration,
    animationTimingFunction: token.motionEaseOutQuint,
    animationIterationCount: 'infinite',
    content: '""'
  })), _defineProperty(_Object$assign, "&".concat(progressCls, "-rtl").concat(progressCls, "-status-active"), _defineProperty({}, "".concat(progressCls, "-bg::before"), {
    animationName: genAntProgressActive(true)
  })), _defineProperty(_Object$assign, "&".concat(progressCls, "-status-exception"), (_$concat8 = {}, _defineProperty(_$concat8, "".concat(progressCls, "-bg"), {
    backgroundColor: token.colorError
  }), _defineProperty(_$concat8, "".concat(progressCls, "-text"), {
    color: token.colorError
  }), _$concat8)), _defineProperty(_Object$assign, "&".concat(progressCls, "-status-exception ").concat(progressCls, "-inner:not(").concat(progressCls, "-circle-gradient)"), _defineProperty({}, "".concat(progressCls, "-circle-path"), {
    stroke: token.colorError
  })), _defineProperty(_Object$assign, "&".concat(progressCls, "-status-success"), (_$concat9 = {}, _defineProperty(_$concat9, "".concat(progressCls, "-bg"), {
    backgroundColor: token.colorSuccess
  }), _defineProperty(_$concat9, "".concat(progressCls, "-text"), {
    color: token.colorSuccess
  }), _$concat9)), _defineProperty(_Object$assign, "&".concat(progressCls, "-status-success ").concat(progressCls, "-inner:not(").concat(progressCls, "-circle-gradient)"), _defineProperty({}, "".concat(progressCls, "-circle-path"), {
    stroke: token.colorSuccess
  })), _Object$assign)));
};
var genCircleStyle = function genCircleStyle(token) {
  var _progressCls, _ref2;
  var progressCls = token.componentCls,
    iconPrefixCls = token.iconCls;
  return _ref2 = {}, _defineProperty(_ref2, progressCls, (_progressCls = {}, _defineProperty(_progressCls, "".concat(progressCls, "-circle-trail"), {
    stroke: token.remainingColor
  }), _defineProperty(_progressCls, "&".concat(progressCls, "-circle ").concat(progressCls, "-inner"), {
    position: 'relative',
    lineHeight: 1,
    backgroundColor: 'transparent'
  }), _defineProperty(_progressCls, "&".concat(progressCls, "-circle ").concat(progressCls, "-text"), _defineProperty({
    position: 'absolute',
    insetBlockStart: '50%',
    insetInlineStart: 0,
    width: '100%',
    margin: 0,
    padding: 0,
    color: token.circleTextColor,
    fontSize: token.circleTextFontSize,
    lineHeight: 1,
    whiteSpace: 'normal',
    textAlign: 'center',
    transform: 'translateY(-50%)'
  }, iconPrefixCls, {
    fontSize: token.circleIconFontSize
  })), _defineProperty(_progressCls, "".concat(progressCls, "-circle&-status-exception"), _defineProperty({}, "".concat(progressCls, "-text"), {
    color: token.colorError
  })), _defineProperty(_progressCls, "".concat(progressCls, "-circle&-status-success"), _defineProperty({}, "".concat(progressCls, "-text"), {
    color: token.colorSuccess
  })), _progressCls)), _defineProperty(_ref2, "".concat(progressCls, "-inline-circle"), _defineProperty({
    lineHeight: 1
  }, "".concat(progressCls, "-inner"), {
    verticalAlign: 'bottom'
  })), _ref2;
};
var genStepStyle = function genStepStyle(token) {
  var progressCls = token.componentCls;
  return _defineProperty({}, progressCls, _defineProperty({}, "".concat(progressCls, "-steps"), {
    display: 'inline-block',
    '&-outer': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    },
    '&-item': {
      flexShrink: 0,
      minWidth: token.progressStepMinWidth,
      marginInlineEnd: token.progressStepMarginInlineEnd,
      backgroundColor: token.remainingColor,
      transition: "all ".concat(token.motionDurationSlow),
      '&-active': {
        backgroundColor: token.defaultColor
      }
    }
  }));
};
var genSmallLine = function genSmallLine(token) {
  var progressCls = token.componentCls,
    iconPrefixCls = token.iconCls;
  return _defineProperty({}, progressCls, _defineProperty({}, "".concat(progressCls, "-small&-line, ").concat(progressCls, "-small&-line ").concat(progressCls, "-text ").concat(iconPrefixCls), {
    fontSize: token.fontSizeSM
  }));
};
export var prepareComponentToken = function prepareComponentToken(token) {
  return {
    circleTextColor: token.colorText,
    defaultColor: token.colorInfo,
    remainingColor: token.colorFillSecondary,
    lineBorderRadius: 100,
    // magic for capsule shape, should be a very large number
    circleTextFontSize: '1em',
    circleIconFontSize: "".concat(token.fontSize / token.fontSizeSM, "em")
  };
};
export default genStyleHooks('Progress', function (token) {
  var progressStepMarginInlineEnd = token.calc(token.marginXXS).div(2).equal();
  var progressToken = mergeToken(token, {
    progressStepMarginInlineEnd: progressStepMarginInlineEnd,
    progressStepMinWidth: progressStepMarginInlineEnd,
    progressActiveMotionDuration: '2.4s'
  });
  return [genBaseStyle(progressToken), genCircleStyle(progressToken), genStepStyle(progressToken), genSmallLine(progressToken)];
}, prepareComponentToken);